(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["axisbreak-engineering-story"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('axisbreak-engineering-story')) {
    customElements.define('axisbreak-engineering-story', class extends HTMLElement {
      connectedCallback() {
        this.stage = this.querySelector('.abx-story__stage');
        this.chapters = Array.from(this.querySelectorAll('[data-chapter]'));
        this.buttons = Array.from(this.querySelectorAll('[data-step]'));
        this.layers = Object.fromEntries(['assembly', 'solid', 'wire', 'fracture', 'dimensions', 'design', 'print', 'tool'].map(name => [name, this.querySelector('.abx-story__' + name)]));
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.desktop = matchMedia('(min-width: 990px)');
        this.queue = () => { if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.render(); }); };
        this.configure = () => {
          if (this.scrollRoot) this.scrollRoot.removeEventListener('scroll', this.queue);
          const wrapper = this.closest('.page-wrapper');
          this.scrollRoot = this.desktop.matches && wrapper && /auto|scroll/.test(getComputedStyle(wrapper).overflowY) ? wrapper : window;
          this.scrollRoot.addEventListener('scroll', this.queue, { passive: true });
          const height = this.scrollRoot === window ? window.innerHeight : this.scrollRoot.clientHeight;
          this.style.setProperty('--abxs-view', height + 'px');
          this.classList.toggle('is-animated', !this.motion.matches);
          if (!this.motion.matches && (this.stage.scrollHeight > height + 2 || height < 580)) this.classList.remove('is-animated');
          if (!this.classList.contains('is-animated')) {
            this.chapters.forEach(chapter => { chapter.style.removeProperty('opacity'); chapter.style.removeProperty('transform'); chapter.removeAttribute('aria-hidden'); });
            Object.values(this.layers).forEach(layer => { layer.style.removeProperty('opacity'); layer.style.removeProperty('transform'); });
          }
          this.queue();
        };
        this.clickStep = event => {
          const button = event.target.closest('[data-step]');
          if (!button || !this.contains(button) || !this.classList.contains('is-animated')) return;
          const rootTop = this.scrollRoot === window ? 0 : this.scrollRoot.getBoundingClientRect().top;
          const current = this.scrollRoot === window ? window.scrollY : this.scrollRoot.scrollTop;
          const start = current + this.getBoundingClientRect().top - rootTop;
          const travel = this.offsetHeight - this.stage.offsetHeight;
          this.scrollRoot.scrollTo({ top: start + (Number(button.dataset.step) / 3) * travel, behavior: this.motion.matches ? 'instant' : 'smooth' });
        };
        this.addEventListener('click', this.clickStep);
        window.addEventListener('resize', this.configure, { passive: true });
        this.motion.addEventListener('change', this.configure);
        this.desktop.addEventListener('change', this.configure);
        this.resizeObserver = new ResizeObserver(() => {
          if (this.classList.contains('is-animated') && this.stage.scrollHeight > this.stage.clientHeight + 2) this.configure();
        });
        this.resizeObserver.observe(this.stage);
        this.configure();
      }
      render() {
        if (!this.classList.contains('is-animated')) return;
        const rootTop = this.scrollRoot === window ? 0 : this.scrollRoot.getBoundingClientRect().top;
        const rect = this.getBoundingClientRect();
        const travel = this.offsetHeight - this.stage.offsetHeight;
        const progress = Math.min(1, Math.max(0, (rootTop - rect.top) / Math.max(1, travel)));
        const scene = progress * 3;
        const active = Math.round(scene);
        this.chapters.forEach((chapter, i) => {
          const weight = Math.max(0, 1 - Math.abs(scene - i) * 1.65);
          chapter.style.opacity = weight.toFixed(3);
          chapter.style.transform = 'translateY(' + ((i - scene) * 22).toFixed(2) + 'px)';
          chapter.setAttribute('aria-hidden', String(i !== active));
        });
        this.buttons.forEach((button, i) => { if (i === active) button.setAttribute('aria-current', 'step'); else button.removeAttribute('aria-current'); });
        const clamp = value => Math.max(0, Math.min(1, value));
        const measure = clamp(scene);
        const design = clamp(scene - 1);
        const manufacture = clamp(scene - 2);
        this.layers.assembly.style.transform = 'translateY(' + (-design * 12 + manufacture * 12).toFixed(2) + 'px) scale(' + (1 + measure * .05 - manufacture * .05).toFixed(3) + ')';
        this.layers.fracture.style.opacity = (1 - measure).toFixed(3);
        this.layers.wire.style.opacity = (1 - manufacture * .85).toFixed(3);
        this.layers.dimensions.style.opacity = (measure * (1 - manufacture)).toFixed(3);
        this.layers.solid.style.opacity = manufacture.toFixed(3);
        this.layers.design.style.opacity = (design * (1 - manufacture * .6)).toFixed(3);
        this.layers.design.style.transform = 'translateY(' + ((1 - design) * -35).toFixed(2) + 'px)';
        this.layers.print.style.opacity = manufacture.toFixed(3);
        this.layers.tool.style.opacity = (Math.sin(manufacture * Math.PI)).toFixed(3);
        this.layers.tool.style.transform = 'translateX(' + ((manufacture - .5) * 150).toFixed(2) + 'px)';
      }
      disconnectedCallback() {
        if (this.frame) cancelAnimationFrame(this.frame);
        if (this.scrollRoot) this.scrollRoot.removeEventListener('scroll', this.queue);
        window.removeEventListener('resize', this.configure);
        this.motion.removeEventListener('change', this.configure);
        this.desktop.removeEventListener('change', this.configure);
        this.removeEventListener('click', this.clickStep);
        this.resizeObserver.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
